import { ProfilerService } from "../service/asyncBatchProfilerService";
import * as validations from "../utils/validations";

export class ProfilerFunctions {
  fnBurgissUniverseCalcIRRProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcIRRPercentile(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcMIRRProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    indexID = validations.validIndexId(indexID);
    if (indexID == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcMIRRProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      indexID,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcRIRRProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcRIRRProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcDPIProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcDPIProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcRVPIProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcRVPIProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcTVPIProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcTVPIProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcDistributionsProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcDistributionsProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcDistributions_AnnualProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcDistributions_AnnualProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcNetCashFlowProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcNetCashFlowProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcNetCashFlow_AnnualProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcNetCashFlow_AnnualProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcPaidInCapitalProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcPaidInCapitalProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcPaidInCapital_AnnualProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcPaidInCapital_AnnualProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcValuationProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcValuationProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcGGS_DirectAlphaProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    indexID = validations.validIndexId(indexID);
    if (indexID == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcGGS_DirectAlphaProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      indexID,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcKS_PMEProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    indexID = validations.validIndexId(indexID);
    if (indexID == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcKS_PMEProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      indexID,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcLN_ICMIRRProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    indexID = validations.validIndexId(indexID);
    if (indexID == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcLN_ICMIRRProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      indexID,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcLN_ICMIRRSpreadProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    indexID = validations.validIndexId(indexID);
    if (indexID == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcLN_ICMIRRSpreadProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      indexID,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcLN_ICMValuationSpreadProfiler(
    peergroupID: any[][],
    percentile: any,
    year: any,
    currency: any,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    year = validations.isValidYear(year);
    if (year == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (year == "-1") {
      return "#INVALIDPARAMETERS - Year not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    indexID = validations.validIndexId(indexID);
    if (indexID == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new ProfilerService().burgissUniverseCalcLN_ICMValuationSpreadProfiler(
      peergroupID,
      percentile,
      year,
      currency,
      indexID,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
}
